import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202512",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 54858,
  clicks: 1100,
  adsSpendDollars: 2745,
  budgetDollars: 3300,
  salesDollars: 14118,
  bestEstimateRoas: 5.14,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.83,
  newCustomersAcquired: 32,
  reorderConversions: 3,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
